import { useContext } from "react";
import { LanguageContext } from "App";
import { downloadReceiptPdf } from "../Classes/API/ReceiptsApi";

const GenerateReceiptButton = ({ receiptId }) => {
  const { translations } = useContext(LanguageContext);

  const handleDownloadReceipt = async () => {
    try {
      const blob = await downloadReceiptPdf(receiptId);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `Receipt_${receiptId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading receipt:", error);
    }
  };

  return (
    <button className="btn btn-primary" onClick={handleDownloadReceipt}>
      {translations.PrintReceipt}
    </button>
  );
};

export default GenerateReceiptButton;
